const state = {
    theme: "",
}

const mutations = {
    CHANGE_THEME: (state, value) => {
        let currentTime = new Date().getHours();
        if (currentTime >= 6 && currentTime < 18) {
            state.theme = "day"
        } else {
            state.theme = "night"
        }
    }
}

const actions = {
    changeTheme({ commit }) {
        commit("CHANGE_THEME");
    },

}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}